import { NextRouter } from "next/router";

import { moEngageUserLogOut } from "@vahak/core/dist/_services/user-analytics.service";
import { handleLogout } from "@vahak/core/dist/methods/handleLogout";
import { IAppContext } from "@vahak/core/dist/app-context";

export interface PerformLogoutAndRedirectHomeParams {
    router: NextRouter;
    setCompanyId: IAppContext["setCompanyId"];
    setIsPhoneVerified: IAppContext["setIsPhoneVerified"];
    setName: IAppContext["setName"];
    setLang: IAppContext["setLang"];
    setCompanyLogo: IAppContext["setCompanyLogo"];
    setUserId: IAppContext["setUserId"];
    setCsDashboardUserRoles?: IAppContext["setCsDashboardUserRoles"];
    setCustomerCompanyId?: IAppContext["setCustomerCompanyId"];
    setCustomerPhone?: IAppContext["setCustomerPhone"];
    setCustomerName?: IAppContext["setCustomerName"];
    phoneNum?: number;
    setShowBankAddPopup?: IAppContext["setShowBankAddPopup"];
    setSessionId: IAppContext["setSessionId"];
    setThirdPartyCompanyName?: IAppContext["setThirdPartyCompanyName"];
}

export async function performLogoutAndRedirectHome({ router, ...logoutParams }: PerformLogoutAndRedirectHomeParams) {
    handleLogout(logoutParams);
    moEngageUserLogOut();
    await router.replace("/", undefined, { shallow: true, scroll: false });
}
